import { IContent } from '../types/IContent';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUser } from '../types/IUser';
import { Request } from './Request';

export interface ExploreContentParams extends IGetItemsParams {
  project?: string;
}

export interface IExploreContentResult extends IGetItemsResult {
  content: IContent[];
  users: IUser[];
}

export class ExploreContentRequest extends Request<ExploreContentParams, IExploreContentResult> {
  constructor(params: ExploreContentParams) {
    super('exploreContent', params);
  }
}
